/**
 * Breadcrumb.tsx — Displays current page title based on route.
 */

import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'

export const ROUTE_TITLES: Record<string, string> = {
  '/': 'nav.dashboard',
  '/calendar': 'nav.calendar',
  '/patients': 'nav.patients',
  '/doctors': 'nav.doctors',
  '/operations': 'nav.operations',
  '/scheduling': 'nav.scheduling',
  '/resources': 'nav.resources',
  '/billing': 'nav.billing',
  '/accounting': 'nav.accounting',
  '/billing/analytics': 'nav.kpiDashboard',
  '/services': 'nav.services',
  '/tasks': 'nav.tasks',
  '/documents': 'nav.documents',
  '/prescriptions': 'nav.prescriptions',
  '/lab': 'nav.lab',
  '/imaging': 'nav.imaging',
  '/messaging': 'nav.messaging',
  '/medical-reports': 'nav.medicalReports',
  '/translator': 'nav.translator',
  '/settings': 'nav.settings',
  '/doctor-hours': 'nav.doctorHours',
  '/doctor-absences': 'nav.absences',
}

/**
 * Resolve the i18n title key for a pathname: exact match first, else the
 * longest matching path prefix (so detail routes like /imaging/studies/4
 * fall back to their section title), else the dashboard.
 */
export function resolveRouteTitleKey(pathname: string): string {
  const exact = ROUTE_TITLES[pathname]
  if (exact) return exact
  const sorted = Object.keys(ROUTE_TITLES)
    .filter(k => pathname.startsWith(k) && k !== '/')
    .sort((a, b) => b.length - a.length)
  return sorted[0] ? ROUTE_TITLES[sorted[0]] : 'nav.dashboard'
}

export default function Breadcrumb() {
  const { t } = useTranslation()
  const loc = useLocation()
  return <h1>{t(resolveRouteTitleKey(loc.pathname))}</h1>
}
